(function() {
  var DialogController, Product,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  DialogController = App.loadClass('core::Angular/DialogController');

  Product = App.loadClass('portal::Angular/Ratings/Models/Product');

  exports.EditProductDialogController = (function(superClass) {
    extend(EditProductDialogController, superClass);

    function EditProductDialogController(scope, transitions, repo, modalInstance, $timeout, q, lineups_id, product) {
      var p, sc, self, tp;
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.modalInstance = modalInstance;
      this.q = q;
      this.cancel = bind(this.cancel, this);
      this.clearAllTooltips = bind(this.clearAllTooltips, this);
      this.actuallySaveData = bind(this.actuallySaveData, this);
      this.save = bind(this.save, this);
      this.markValid = bind(this.markValid, this);
      this.markInvalid = bind(this.markInvalid, this);
      this._isUniqueProduct = bind(this._isUniqueProduct, this);
      this.validateTraitPackage = bind(this.validateTraitPackage, this);
      this.validateName = bind(this.validateName, this);
      this.validateSeedCompany = bind(this.validateSeedCompany, this);
      this.traitPackagesChanged = bind(this.traitPackagesChanged, this);
      this.seedCompaniesChanged = bind(this.seedCompaniesChanged, this);
      this.beforeValidate = bind(this.beforeValidate, this);
      this.beforeKeyDown = bind(this.beforeKeyDown, this);
      this.afterRender = bind(this.afterRender, this);
      this.attachButtons = bind(this.attachButtons, this);
      EditProductDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      self = this;
      p = new Product();
      $.extend(p, product);
      p.seed_company_name = _.find(this.scope.$parent.seed_companies, {
        id: p.seed_companies_id
      }).name;
      p.trait_package_name = _.find(this.scope.$parent.trait_packages, {
        id: p.trait_packages_id
      }).name;
      this.existing_companies = this.scope.$parent.seed_companies;
      this.existing_traits = this.scope.$parent.trait_packages;
      this.existing_products = this.scope.$parent.existing_products;
      this.original_product = product;
      this.scope.product = [p];
      this.scope.title = 'Edit Product';
      this.scope.absolute_errors = false;
      this.scope.show_overflow = true;
      this.lineups_id = lineups_id;
      this.scope.hot_settings = {
        currentColClassName: 'highlighted',
        currentRowClassName: 'highlighted',
        invalidCellClassName: 'invalid',
        allowInsertColumn: false,
        allowRemoveColumn: false,
        maxRows: 1,
        allowInsertRow: false,
        allowRemoveRow: false,
        rowHeaders: false,
        afterInit: function() {
          return self.hot = this;
        },
        afterRender: this.afterRender,
        beforeKeyDown: this.beforeKeyDown,
        beforeValidate: this.beforeValidate
      };
      this.scope.$watchCollection('$parent.seed_companies', this.seedCompaniesChanged);
      this.scope.$watch('$parent.trait_packages', this.traitPackagesChanged, true);
      this.seed_company_names = (function() {
        var i, len, ref, results;
        ref = this.scope.$parent.seed_companies;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          sc = ref[i];
          results.push(sc.name);
        }
        return results;
      }).call(this);
      this.trait_package_names = (function() {
        var i, len, ref, results;
        ref = this.scope.$parent.trait_packages;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          tp = ref[i];
          if (tp.active) {
            results.push(tp.name);
          }
        }
        return results;
      }).call(this);
      this.valid = true;
      this.scope.validateSeedCompany = this.validateSeedCompany;
      this.scope.validateName = this.validateName;
      this.scope.validateTraitPackage = this.validateTraitPackage;
      $timeout((function(_this) {
        return function() {
          _this.tp_button = $('.btn-add-trait-package').detach();
          return _this.attachButtons();
        };
      })(this));
    }

    EditProductDialogController.prototype.attachButtons = function() {
      return $('.edit-product-hot thead th:nth-child(3)>div').append(this.tp_button);
    };

    EditProductDialogController.prototype.afterRender = function() {
      return this.attachButtons();
    };

    EditProductDialogController.prototype.beforeKeyDown = function(e) {
      if (e.which === 27) {
        return e.stopPropagation();
      }
    };

    EditProductDialogController.prototype.beforeValidate = function(value, row, prop, source) {
      var cell;
      cell = {
        value: value,
        row: row,
        prop: prop,
        elem: this.hot.getCell(row, this.hot.propToCol(prop))
      };
      return cell;
    };

    EditProductDialogController.prototype.seedCompaniesChanged = function(seed_companies) {
      var sc;
      this.scope.product[0].seed_companies = seed_companies;
      return this.seed_company_names = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = seed_companies.length; i < len; i++) {
          sc = seed_companies[i];
          results.push(sc.name);
        }
        return results;
      })();
    };

    EditProductDialogController.prototype.traitPackagesChanged = function(trait_packages) {
      var tp;
      this.scope.product[0].trait_packages = trait_packages;
      return this.trait_package_names = (function() {
        var i, len, results;
        results = [];
        for (i = 0, len = trait_packages.length; i < len; i++) {
          tp = trait_packages[i];
          if (tp.active) {
            results.push(tp.name);
          }
        }
        return results;
      })();
    };

    EditProductDialogController.prototype.validateSeedCompany = function(cell, callback) {
      var product, ref;
      if (ref = cell.value, indexOf.call(this.seed_company_names, ref) < 0) {
        return this.markInvalid(cell, 'Seed Company is required (Hint: Input must exactly match one of\nthe Seed Companies you\'ve already added. If you don\'t see the\nSeed Company in the dropdown list, please contact MyFarms\nSupport.)', callback);
      }
      if (!this._isUniqueProduct(cell)) {
        product = this.hot.getSourceDataAtRow(cell.row);
        return this.markInvalid(cell, "You already have a Product with the Seed Company\n\"" + cell.value + "\", the Name \"" + product.name + "\", and the Trait\nPackage \"" + product.trait_package_name + "\"", callback);
      }
      return this.markValid(cell, callback);
    };

    EditProductDialogController.prototype.validateName = function(cell, callback) {
      var product;
      if (cell.value === '') {
        return this.markInvalid(cell, 'Name is required', callback);
      }
      if (cell.value.length > 50) {
        return this.markInvalid(cell, 'Name cannot be longer than 50 characters', callback);
      }
      if (!this._isUniqueProduct(cell)) {
        product = this.hot.getSourceDataAtRow(cell.row);
        return this.markInvalid(cell, "You already have a Product with the Seed Company\n\"" + product.seed_company_name + "\", the Name \"" + cell.value + "\",\nand the Trait Package \"" + product.trait_package_name + "\"", callback);
      }
      return this.markValid(cell, callback);
    };

    EditProductDialogController.prototype.validateTraitPackage = function(cell, callback) {
      var product, ref;
      if (ref = cell.value, indexOf.call(this.trait_package_names, ref) < 0) {
        return this.markInvalid(cell, 'Trait Package is required (Hint: Input must exactly match one of\nthe Trait Packages you\'ve already added. If you don\'t see the\nTrait Package in the dropdown list, you can add it now by\nclicking the "+" button above.)', callback);
      }
      if (!this._isUniqueProduct(cell)) {
        product = this.hot.getSourceDataAtRow(cell.row);
        return this.markInvalid(cell, "You already have a Product with the Seed Company\n\"" + product.seed_company_name + "\", the Name \"" + product.name + "\",\nand the Trait Package \"" + cell.value + "\"", callback);
      }
      return this.markValid(cell, callback);
    };


    /*
    use given cell to validate unique product names
     */

    EditProductDialogController.prototype._isUniqueProduct = function(cell) {
      var duplicates, edited, is_same, sc, tp;
      edited = $.extend({}, this.hot.getSourceDataAtRow(cell.row));
      edited[cell.prop] = cell.value;
      if (!edited.name || !edited.seed_company_name || !edited.trait_package_name) {
        return true;
      }
      tp = _.find(this.existing_traits, {
        'name': edited.trait_package_name
      });
      sc = _.find(this.existing_companies, {
        'name': edited.seed_company_name
      });
      if (!tp || !sc) {
        return true;
      }
      edited.trait_packages_id = tp.id;
      edited.seed_companies_id = sc.id;
      duplicates = _.filter(this.existing_products, (function(_this) {
        return function(p) {
          var same_name, same_sc, same_trait;
          same_name = p.name.trim() === edited.name.trim();
          same_sc = p.seed_companies_id === edited.seed_companies_id;
          same_trait = p.trait_packages_id === edited.trait_packages_id;
          return same_name && same_sc && same_trait;
        };
      })(this));
      is_same = edited.seed_companies_id === this.original_product.seed_companies_id && edited.trait_packages_id === this.original_product.trait_packages_id && edited.name === this.original_product.name;
      return duplicates.length === 0 || is_same;
    };

    EditProductDialogController.prototype.markInvalid = function(cell, msg, callback) {
      var ref;
      if (callback == null) {
        callback = null;
      }
      if ((ref = this.hot.getSourceDataAtRow(cell.row)) != null) {
        ref["_" + cell.prop + "_validation"] = {
          status: 'invalid',
          message: msg
        };
      }
      this.valid = false;
      if (typeof callback === "function") {
        callback(false);
      }
      return false;
    };

    EditProductDialogController.prototype.markValid = function(cell, callback) {
      var ref;
      if (callback == null) {
        callback = null;
      }
      if ((ref = this.hot.getSourceDataAtRow(cell.row)) != null) {
        ref["_" + cell.prop + "_validation"] = {
          status: 'success',
          message: null
        };
      }
      if (typeof callback === "function") {
        callback(true);
      }
      return true;
    };

    EditProductDialogController.prototype.save = function() {
      var deferred;
      this.valid = true;
      deferred = this.q.defer();
      this.hot.validateCells((function(_this) {
        return function() {
          var result;
          if (_this.valid) {
            result = _this.actuallySaveData();
            return deferred.resolve(result);
          } else {
            return deferred.reject();
          }
        };
      })(this));
      this.clearAllTooltips();
      return deferred.promise;
    };

    EditProductDialogController.prototype.actuallySaveData = function() {
      var product, promise, seed_companies, trait_packages;
      this.setAlert({
        type: 'info',
        msg: 'Saving product'
      });
      seed_companies = this.scope.$parent.seed_companies;
      trait_packages = this.scope.$parent.trait_packages;
      product = this.scope.product[0];
      product.seed_companies_id = _.find(seed_companies, {
        name: product.seed_company_name
      }).id;
      product.trait_packages_id = _.find(trait_packages, {
        name: product.trait_package_name
      }).id;
      promise = this.repo.updateProduct(this.lineups_id, product).then((function(_this) {
        return function(response) {
          var ref;
          if ((ref = response.status) != null ? ref.type : void 0) {
            return _this.closeWithAlert(response.status, response.data);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.closeWithAlert({
            type: 'error',
            msg: 'Failed to save product'
          });
        };
      })(this));
      return promise;
    };

    EditProductDialogController.prototype.clearAllTooltips = function() {
      return $('.qtip').each(function() {
        return $(this).data('qtip').destroy();
      });
    };

    EditProductDialogController.prototype.cancel = function() {
      this.clearAllTooltips();
      return EditProductDialogController.__super__.cancel.call(this);
    };

    return EditProductDialogController;

  })(DialogController);

}).call(this);
